export default __webpack_public_path__ + "BackgroundSignNewVersion.bda089f.png";